import { render, staticRenderFns } from "./UpdatePlan.vue?vue&type=template&id=d2dd654a&scoped=true"
import script from "./UpdatePlan.vue?vue&type=script&lang=js"
export * from "./UpdatePlan.vue?vue&type=script&lang=js"
import style0 from "./UpdatePlan.vue?vue&type=style&index=0&id=d2dd654a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2dd654a",
  null
  
)

export default component.exports